import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Card, Input } from "@nextui-org/react";
import { Icon } from "@iconify/react";

const ChatOutputNode = ({ data }) => {
  return (
    <Card className="py-4 w-[300px]">
      <div className="space-y-4 ">
        <div className="flex items-center gap-2 px-4">
          <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            💬
          </div>
          <span className="font-medium font-semibold">Chat Output</span>
        </div>

        <div className="text-sm text-gray-500 px-4">
          Display a chat message in the Playground.
        </div>

        <div className="space-y-2 relative">
          <div className="flex items-center justify-between px-4 ">
            <span className="text-sm font-semibold">Text</span>
            <Icon icon="ph:eye" className="w-4 h-4 text-gray-400" />
          </div>
          <div className="px-4">
            <Input
              placeholder="Receiving input"
              isReadOnly
              className="max-w-full"
            />
          </div>
          <Handle
            type="target"
            position={Position.Left}
            id="input"
            // className="w-3 h-3 bg-blue-500"
            className={`!w-3 !h-3 !top-1/2 left-0 absolute border-none bg-blue-500 `}
          />
        </div>

        <div className="flex items-center justify-between px-4">
          <span className="text-sm">Message</span>
          <Icon icon="ph:eye" className="w-4 h-4 text-gray-400" />
        </div>
      </div>
    </Card>
  );
};

export default ChatOutputNode;
